import { useThemeType } from '@gravity-ui/uikit';
import { Palette, usePalette } from '@/app/providers/PaletteProvider';

const fields: { name: keyof Palette; label: string; description: string }[] = [
    { name: 'canvas', label: 'Фон страницы', description: 'Основной фон интерфейса' },
    { name: 'surface', label: 'Панели и карточки', description: 'Поверхности с данными и управлением' },
    { name: 'ink', label: 'Текст', description: 'Заголовки и основные надписи' },
    { name: 'accent', label: 'Акцент', description: 'Выбранные значения и выделения' },
];
export function PaletteSettings() {
    const { palette, update, storageError } = usePalette();
    const theme = useThemeType();
    return <section className="palette-settings" aria-labelledby="palette-title">
        <span className="eyebrow">Ваш интерфейс</span>
        <h1 id="palette-title">Настройки</h1>
        <p className="muted">Основные цвета · {theme === 'dark' ? 'тёмная' : 'светлая'} тема. Изменения видны сразу и сохраняются в этом браузере.</p>
        <p className="hint">Для другой палитры переключите тему кнопкой в шапке. Цвета статусов остаются узнаваемыми.</p>
        <div className="palette-grid">{fields.map(({ name, label, description }) =>
            <label className="palette-field surface" key={name}>
                <span><strong>{label}</strong><small>{description}</small><code>{palette[name].toUpperCase()}</code></span>
                <input type="color" aria-label={label} value={palette[name]} onChange={event => update({ ...palette, [name]: event.target.value })} />
            </label>
        )}</div>
        <div className="palette-preview surface">
            <span className="eyebrow">Предпросмотр</span><h2>Панель управления</h2>
            <p className="muted">Показания устройства и выбранное значение</p>
            <div className="actions"><span className="device-status is-online"><i />На связи</span><span className="device-status"><i />Нет связи</span><span className="value-chip">Позиция 3</span></div>
        </div>
        <button className="action" onClick={() => update(null)}>Восстановить цвета текущей темы</button>
        <p className={storageError ? 'notice error' : 'hint'} role="status">{storageError ? 'Браузер не разрешил сохранение. Цвета применены только до перезагрузки.' : 'Палитра сохраняется автоматически, только у вас.'}</p>
    </section>;
}
